const type = 'OPEN_ADVANCE_INVOICE_INSTALLMENT';

const openAdvanceInvoiceInstallment = () => ({
  type,
});

export { type };
export default openAdvanceInvoiceInstallment;
